import { Action, createReducer, on } from '@ngrx/store';
import { AppStoreDynamicForm } from './store.dynamic-form';
import { appStoreDynamicFormActions } from './store.dynamic-form.action';
import { appStoreDynamicFormIS } from './store.dynamic-form.state';

const appStoreDynamicFormRegister = createReducer(
  appStoreDynamicFormIS,

  on(appStoreDynamicFormActions.setFormSelectedAction, (state, { form }) => ({
    ...state,
    form,
  })),

  on(appStoreDynamicFormActions.setAnswerFromQuestionAction, (state, { question, answer }) => ({
    ...state,
    answers: {
      ...state.answers,
      [question ?? -1]: answer,
    },
  })),

  on(appStoreDynamicFormActions.resetFormAction, (state) => ({
    ...state,
    form: {},
    answers: {},
  })),
);

export const appStoreDynamicFormReducer = (state: AppStoreDynamicForm, action: Action): any =>
  appStoreDynamicFormRegister(state, action);
